<template>
  <div>
    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isActive"
    >
      <div
        class="mt-6 flex items-center justify-between px-6"
        v-if="stockingTemplate && orgStockingTemplate"
      >
        <div class="flex items-center">
          <img
            v-if="stockingTemplate.imageUrl && stockingTemplate.imageUrl !== ''"
            width="40"
            :src="stockingTemplate.imageUrl"
            class="mr-4"
          />
          <img v-else width="40" :src="ProductIcon" class="mr-4" />
          <div>
            <h4>Assign template to venue</h4>
            <small v-if="stockingTemplate.name"
              >{{ stockingTemplate.name }} (by
              {{ orgStockingTemplate.createdBy.username }})</small
            >
          </div>
        </div>
        <feather-icon
          icon="XIcon"
          @click.stop="isActive = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <Loading v-if="isLoading" />
        <div v-else class="p-6">
          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Select venue</span>
            </div>
            <div>
              <venue-selector
                v-model="filterVenue"
                @venue="onVenueSelected"
                :filterCountries="[activeCountry.name]"
                :globalMode="true"
                :multiple="false"
              />
              <vs-button class="mt-3" color="success" @click="confirmAssign">
                Assign
              </vs-button>
            </div>
          </div>

          <!--  -->
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="closeSidebar"> Go back </vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ProductIcon from "@/assets/images/shout-icon.png";
import { mapGetters } from "vuex";
import PopupAddProduct from "./PopupAddProduct.vue";
import VenueSelector from "@/components/VenueSelector.vue";

export default {
  components: {
    VenueSelector,
    VuePerfectScrollbar,
    PopupAddProduct,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      ProductIcon,

      isActive: false,
      isLoading: true,

      stockingTemplate: null,
      orgStockingTemplate: null,
      filterVenue: null,
    };
  },
  computed: {
    ...mapGetters({
      activeCountry: "venues/activeCountry",
    }),
    isFormValid() {
      return true;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    onVenueSelected(venue) {
      console.log("Selected venue", venue);
    },
    closeSidebar() {
      this.isActive = false;
      this.isLoading = false;
    },
    async show(stockingTemplateId) {
      this.isActive = true;
      this.isLoading = true;

      var result = await this.$store.dispatch(
        "stockingTemplates/getStockingTemplate",
        stockingTemplateId
      );

      this.orgStockingTemplate = result;
      this.stockingTemplate = {
        name: result.name,
        mandatoryStockProducts: result.mandatoryStockProducts.map(
          (e) => e.stockProductId.id
        ),
        optionalStockProducts: result.optionalStockProducts.map(
          (e) => e.stockProductId.id
        ),
        imageUrl: result.imageUrl,
      };

      console.log("Got stocking template", this.stockingTemplate);
      this.isLoading = false;
    },

    async confirmAssign() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Assign this stocking template?`,
        accept: this.assign,
      });
    },
    async assign() {
      console.log(
        "Assigning DTO",
        this.orgStockingTemplate.id,
        this.filterVenue
      );

      const dto = {
        stockingTemplateId: this.orgStockingTemplate.id,
      };

      const result = await this.$store.dispatch(
        "stockingTemplates/assignStockingTemplate",
        {
          venueId: this.filterVenue,
          dto: dto,
        }
      );

      this.$vs.notify({
        title: "Template assigned",
        text: "Template successfully assigned to venue.",
      });

      this.isActive = false;
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>